import { useContext } from 'react';
import { AppContext } from '../../../contexts/AppContext';

export function useUser() {
    const { state } = useContext(AppContext);

    return state?.user;
}
